<!-- 核销员 -->
<template>
    <div class="container">
        <div class="lefter">
            <Button
                class="theme-bc mt12 mb24 ml12"
                icon="md-add-circle"
                type="warning"
                @click="goAddCategory"
                >新增分类</Button
            >
            <div class="card-container">
                <div
                    :class="category_value == index ? 'card-active' : 'card'"
                    v-for="(item, index) of typeList"
                    :key="item.id"
                    @click="goActiveCategory(index, item)"
                >
                    <div>{{ item.name }}</div>
                    <div v-if="item.id != -1" class="category-right">
                        <div>{{ item.guide_count }}</div>
                        <img
                            src="@/assets/diy_input.png"
                            class="help-add-icon"
                            @click.stop="goAddCategory(item)"
                        />
                        <img
                            src="@/assets/delete.png"
                            class="help-del-icon"
                            @click.stop="goDelCategory(item)"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="content">
            <Button
                class="theme-bc mb24"
                icon="md-add-circle"
                type="warning"
                @click="goAddModal"
                >新增审核员</Button
            >
            <Table :columns="columnsTable" :data="dataTable" border>
                <template slot-scope="{ row }" slot="name">
                    <div>{{ row.customer ? row.customer.name : "" }}</div>
                </template>
                <template slot-scope="{ row }" slot="phone">
                    <div>{{ row.customer ? row.customer.phone : "" }}</div>
                </template>
                <template slot-scope="{ row }" slot="writeoff_count">
                    <Button type="primary" @click="goViewWriteoff(row)">{{ row.writeoff_count || 0 }}</Button>
                </template>
                <template slot-scope="{ row }" slot="status">
                    <span v-if="row.status == 1" style="color: #19be6b;">正常</span>
                    <span v-else style="color: #ed4014;">禁用</span>
                </template>
                <template slot-scope="{ row }" slot="operate">
                    <Button
                        v-if="row.status == 1"
                        type="warning" 
                        ghost 
                        size="small" 
                        @click="goToggleStatus(row)"
                        >禁用</Button
                    >
                    <Button 
                        v-else
                        type="success" 
                        ghost 
                        size="small" 
                        @click="goToggleStatus(row)"
                        >启用</Button
                    >
                    <Button type="error" ghost size="small" @click="goDel(row)" style="margin-left: 8px;"
                        >删除</Button
                    >
                </template>
            </Table>
            <div class="text-align-right mt24">
                <Page
                    :current="storePrams.page"
                    :page-size="storePrams.limit"
                    :total="total"
                    show-total
                    @on-change="goChangePage"
                />
            </div>
        </div>

        <!-- 新增/编辑 -->
        <Modal
            v-model="addModal"
            title="新增导购员"
            width="500"
            :mask-closable="false"
        >
            <Form
                :model="formItem"
                label-position="right"
                :label-width="100"
                class="mt24"
            >
                <FormItem label="选择导购员：">
                    <Select
                        class="w300"
                        v-model="formItem.customer_id"
                        clearable
                        filterable
                        placeholder="请选择导购员"
                    >
                        <Option
                            v-for="item in customerList"
                            :value="item.id"
                            :key="item.id"
                            :label="`${item.name} ${item.phone}`"
                        />
                    </Select>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="goCancelModal">取消</Button>
                <Button class="theme-bc" type="warning" @click="goSubmitModal"
                    >确认</Button
                >
            </div>
        </Modal>
        <!-- 新增分类/编辑分类 -->
        <Modal
            v-model="addCategoryModal"
            :title="addCategoryModalTitle"
            width="500"
            :mask-closable="false"
        >
            <Form
                :model="formCategoryItem"
                label-position="right"
                :label-width="100"
                class="mt24"
            >
                <FormItem label="分类名称：">
                    <Input
                        class="w300"
                        type="text"
                        v-model="formCategoryItem.name"
                        placeholder="请输入分类名称"
                    ></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="goCancelCategoryModal">取消</Button>
                <Button
                    class="theme-bc"
                    type="warning"
                    @click="goSubmitCategoryModal"
                    >确认</Button
                >
            </div>
        </Modal>

        <!-- 核销记录弹框 -->
        <Modal
            v-model="writeoffModal"
            :title="writeoffTitle"
            width="900"
            :mask-closable="false"
        >
            <Table :columns="writeoffColumns" :data="writeoffList" border>
                <template slot-scope="{ row }" slot="status">
                    <span v-if="row.status == '待审核'" style="color: #ed4014;">{{ row.status }}</span>
                    <span v-else-if="row.status == '已完成'" style="color: #19be6b;">{{ row.status }}</span>
                    <span v-else>{{ row.status }}</span>
                </template>
            </Table>
            <div class="text-align-right mt24">
                <Page
                    :current="writeoffParams.page"
                    :page-size="writeoffParams.limit"
                    :total="writeoffTotal"
                    show-total
                    @on-change="goChangeWriteoffPage"
                />
            </div>
            <div slot="footer">
                <Button @click="writeoffModal = false">关闭</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import {
    shopping_list,
    shopping_save,
    shopping_delete,
    shopping_type,
    shopping_type_save,
    shopping_type_delete,
    customer_select,
    shopping_status,
    shopping_writeoff_list,
} from "@/api/index";
export default {
    data() {
        return {
            storePrams: {
                page: 1,
                limit: 30,
                type_id: -1,
            },
            total: 0,
            columnsTable: [
                { type: "index", width: 60, align: "center" },
                { title: "用户名称", slot: "name", align: "center" },
                { title: "手机号", slot: "phone", align: "center" },
                { title: "核销数量", slot: "writeoff_count", align: "center" },
                { title: "状态", slot: "status", align: "center" },
                {
                    title: "操作",
                    slot: "operate",
                    align: "center",
                    width: "180px",
                },
            ],
            dataTable: [],
            addModal: false,
            formItem: {
                type_id: -1,
                customer_id: "",
            },
            typeList: [{ id: -1, name: "全部" }],
            category_value: 0,
            addCategoryModal: false,
            addCategoryModalTitle: "",
            formCategoryItem: {
                id: "",
                name: "",
            },
            customerList: [],
            // 核销记录弹框
            writeoffModal: false,
            writeoffTitle: "核销数量",
            writeoffList: [],
            writeoffTotal: 0,
            writeoffParams: {
                page: 1,
                limit: 20,
                shopping_id: "",
            },
            // 核销记录表格列
            writeoffColumns: [
                { type: "index", width: 60, align: "center" },
                { title: "中奖的溯源码", key: "qrcode", align: "center" },
                { title: "奖品名称", key: "prize_name", align: "center" },
                { title: "状态", slot: "status", align: "center" },
                { title: "核销时间", key: "writeoff_time", align: "center" },
            ],
        };
    },
    mounted() {
        this.getShoppingType();
        this.getProductSelect();
    },
    methods: {
        // 用户下拉列表
        getProductSelect() {
            customer_select()
                .then((res) => {
                    this.customerList = res.data;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        getShoppingType() {
            shopping_type()
                .then((res) => {
                    // 1. 获取接口返回列表
                    const list = res.data?.data || [];

                    // 2. 【关键】最前面插入一个「全部」选项
                    const allItem = {
                        id: -1, // 全部用 -1，和你原来逻辑一致
                        name: "全部", // 显示文字，可自己改
                    };
                    this.typeList = [allItem, ...list]; // 全部放在第一个

                    // 3. 默认选中第一个（也就是「全部」）
                    this.storePrams.type_id = this.typeList[0].id;
                    this.formItem.type_id = this.typeList[0].id;

                    this.getList();
                })
                .catch((err) => {
                    this.$Message.error(err.msg || "获取分类失败");

                    // 4. 失败时，也只显示「全部」
                    this.typeList = [{ id: -1, name: "全部" }];

                    // 同样默认选中
                    this.storePrams.type_id = -1;
                    this.formItem.type_id = -1;
                });
        },
        getList() {
            shopping_list(this.storePrams)
                .then((res) => {
                    this.dataTable = res.data?.data || [];
                    this.total = res.data?.total || 0;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                    this.dataTable = [];
                    this.total = 0;
                });
        },
        goChangePage(index) {
            this.storePrams.page = index;
            this.getList();
        },
        goAddModal() {
            this.formItem.customer_id = "";
            this.$nextTick(() => {
                this.addModal = true;
            });
        },
        // 确定
        goSubmitModal() {
            if (!this.formItem.customer_id) {
                this.$Message.warning("请选择导购员");
                return;
            }
            shopping_save(this.formItem)
                .then((res) => {
                    this.getList();
                    this.addModal = false;
                    this.$Message.success(res.msg);
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        goCancelModal() {
            this.addModal = false;
        },
        goDel(row) {
            this.$Modal.confirm({
                title: "删除提示",
                content: "确认删除吗？",
                onOk: () => {
                    shopping_delete({ id: row.id })
                        .then((res) => {
                            this.getList();
                            this.$Message.success(res.msg);
                        })
                        .catch((err) => {
                            this.$Message.error(err.msg);
                        });
                },
                onCancel: () => {},
            });
        },
        goActiveCategory(index, item) {
            this.category_value = index;
            if (item) {
                this.storePrams.type_id = item.id;
                this.formItem.type_id = item.id;
            }
            this.getList();
        },
        goAddCategory(item) {
            if (item.id) {
                this.addCategoryModalTitle = "编辑分类";
                this.formCategoryItem.id = item.id;
                this.formCategoryItem.name = item.name;
            } else {
                this.addCategoryModalTitle = "新增分类";
                this.formCategoryItem.id = "";
                this.formCategoryItem.name = "";
            }
            this.addCategoryModal = true;
        },
        // 确定
        goSubmitCategoryModal() {
            if (!this.formCategoryItem.name.trim()) {
                this.$Message.warning("请输入分类名称");
                return;
            }
            shopping_type_save(this.formCategoryItem)
                .then((res) => {
                    this.getShoppingType();
                    this.addCategoryModal = false;
                    this.$Message.success(res.msg);
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        goCancelCategoryModal() {
            this.addCategoryModal = false;
        },
        goDelCategory(item) {
            this.$Modal.confirm({
                title: "删除提示",
                content: "确认删除吗？",
                onOk: () => {
                    shopping_type_delete({ id: item.id })
                        .then((res) => {
                            this.getShoppingType();
                            // 如果删除的是当前选中的分类，重置选中状态
                            if (this.storePrams.type_id === item.id) {
                                this.storePrams.type_id = -1;
                                this.formItem.type_id = -1;
                                this.category_value = 0;
                            }
                            this.$Message.success(res.msg);
                        })
                        .catch((err) => {
                            this.$Message.error(err.msg);
                        });
                },
                onCancel: () => {},
            });
        },
        // 切换核销员状态（启用/禁用）
        goToggleStatus(row) {
            const newStatus = row.status == 1 ? 0 : 1;
            const actionText = newStatus == 1 ? "启用" : "禁用";
            
            this.$Modal.confirm({
                title: `${actionText}提示`,
                content: `确认${actionText}该核销员吗？`,
                onOk: () => {
                    shopping_status({ id: row.id, status: newStatus })
                        .then((res) => {
                            this.getList();
                            this.$Message.success(res.msg || `${actionText}成功`);
                        })
                        .catch((err) => {
                            this.$Message.error(err.msg);
                        });
                },
                onCancel: () => {},
            });
        },
        // 查看核销记录
        goViewWriteoff(row) {
            this.writeoffTitle = `核销数量 - ${row.customer ? row.customer.name : ''}`;
            this.writeoffParams.shopping_id = row.id;
            this.writeoffParams.page = 1;
            this.writeoffModal = true;
            this.getWriteoffList();
        },
        // 获取核销记录列表
        getWriteoffList() {
            shopping_writeoff_list(this.writeoffParams)
                .then((res) => {
                    this.writeoffList = res.data?.data || [];
                    this.writeoffTotal = res.data?.total || 0;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                    this.writeoffList = [];
                    this.writeoffTotal = 0;
                });
        },
        // 核销记录分页
        goChangeWriteoffPage(index) {
            this.writeoffParams.page = index;
            this.getWriteoffList();
        },
    },
};
</script>

<style scoped>
.container {
    width: 100%;
    display: flex;
    flex-direction: row;
}
.lefter {
    padding: 12px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    width: 30%;
    border-right: 1px solid #eee;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    width: 70%;
}
.text-align-right {
    text-align: right;
}
.card-container {
    width: 100%;
}
.card-active {
    padding: 10px;
    background: #e8eaf4;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #000000;
    cursor: pointer;
}
.card {
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #666666;
    cursor: pointer;
}
.category-right {
    margin-left: 24px;
    display: flex;
    align-items: center;
}
.help-add-icon {
    margin-left: 24px;
    min-width: 14px;
    width: 14px;
    min-height: 14px;
    height: 14px;
}
.help-del-icon {
    margin: 0 2px 0 12px;
    min-width: 20px;
    width: 20px;
    min-height: 20px;
    height: 20px;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
</style>